import type React from 'react';
import { type FC, useState } from 'react';

import classNames from 'classnames';

import styles from './image.module.css';

const Image: FC<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
> = (props) => {
  const { className } = props;
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      {...props}
      onLoad={(event) => {
        setLoaded(true);
        props.onLoad?.(event);
      }}
      alt={props.alt ?? ''}
      className={classNames(className, styles.image, {
        [styles.loaded]: loaded,
      })}
    />
  );
};

export default Image;
